import LeadsList from "../../components/leads/LeadsList"

const LeadsListPage = () => {
    return <LeadsList/>
}

export default LeadsListPage